var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex h-13" }, [
    _c(
      "div",
      { staticClass: "analytics-first-col-sticky pl-6 flex bg-slate-100" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center bg-pure-white border-b border-l border-r border-slate-400",
            class: { "rounded-bl": _vm.isLast }
          },
          [
            _c(
              "div",
              {
                staticClass: "w-60 px-4 flex flex-shrink-0",
                attrs: { title: _vm.item.client_name }
              },
              [
                _c("BlTextBody2", {
                  staticClass: "text-slate-1000 truncate",
                  attrs: { text: _vm.item.client_name }
                })
              ],
              1
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.enableBranch
      ? _c(
          "div",
          {
            staticClass:
              "w-40 px-4 flex items-center gap-2 flex-shrink-0 bg-pure-white border-b border-slate-400"
          },
          [
            !_vm.item.client_branches || !_vm.item.client_branches.length
              ? _c("BlTextBody2", { attrs: { text: "-" } })
              : _vm._l(_vm.item.client_branches.slice(0, 2), function(i) {
                  return _c(
                    "div",
                    {
                      key: i.id,
                      staticClass:
                        "h-7 min-w-12 px-2 flex items-center justify-center rounded truncate",
                      style: { backgroundColor: i.background_color || "unset" },
                      attrs: { title: i.name }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: i.color || "unset" },
                        attrs: { text: i.name || "-" }
                      })
                    ],
                    1
                  )
                }),
            _vm._v(" "),
            _vm.item.client_branches.slice(2).length
              ? _c("div", { staticClass: "relative" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.moreBranch = !_vm.moreBranch
                        }
                      }
                    },
                    [
                      _c("BlBubbleCount", {
                        staticClass: "h-7 hover:bg-light-purple-100",
                        attrs: {
                          count: "+ " + _vm.item.client_branches.slice(2).length
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.moreBranch
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute top-0 right-0 min-w-32 mt-10 p-1 flex flex-col gap-1 bg-pure-white border border-grey-200 rounded truncate",
                          style: { zIndex: 1 }
                        },
                        _vm._l(_vm.item.client_branches.slice(2), function(
                          i,
                          idx
                        ) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "flex max-w-64" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "px-4 py-2 text-left rounded truncate",
                                  attrs: { title: i.name || "-" }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "truncate",
                                    attrs: { text: i.name || "-" }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-40 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: { text: _vm.item.therapist_on_duty || "-" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex bg-pure-white border-l border-slate-400" }, [
      _c(
        "div",
        {
          staticClass:
            "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.item.client_by_hours || "-" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.item.therapist_by_hours || "-" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.item.clinic_or_admin_by_hours || "-" }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex bg-pure-white border-l border-r border-slate-400" },
      [
        _c(
          "div",
          {
            staticClass:
              "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
          },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.item.client_by_session || "-" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
          },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.item.therapist_by_session || "-" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "w-25 px-4 flex items-center flex-shrink-0 border-b border-slate-400"
          },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.item.clinic_or_admin_by_session || "-" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "w-40 px-4 flex items-center gap-2 flex-shrink-0 bg-pure-white border-b border-slate-400"
      },
      [
        !_vm.item.client_tags || !_vm.item.client_tags.length
          ? _c("BlTextBody2", { attrs: { text: "-" } })
          : _vm._l(_vm.item.client_tags.slice(0, 2), function(i) {
              return _c(
                "div",
                {
                  key: i.id,
                  staticClass:
                    "h-7 min-w-12 px-2 flex items-center justify-center rounded truncate bg-slate-300",
                  attrs: { title: i.name }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "truncate",
                    attrs: { text: i.name || "-" }
                  })
                ],
                1
              )
            }),
        _vm._v(" "),
        _vm.item.client_tags.slice(2).length
          ? _c("div", { staticClass: "relative" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center cursor-pointer",
                  on: {
                    click: function($event) {
                      _vm.moreTags = !_vm.moreTags
                    }
                  }
                },
                [
                  _c("BlBubbleCount", {
                    staticClass: "h-7 hover:bg-light-purple-100",
                    attrs: {
                      count: "+ " + _vm.item.client_tags.slice(2).length
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.moreTags
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-0 right-0 min-w-32 mt-10 p-1 flex flex-col gap-1 bg-pure-white border border-grey-200 rounded truncate",
                      style: { zIndex: 1 }
                    },
                    _vm._l(_vm.item.client_tags.slice(2), function(i, idx) {
                      return _c(
                        "div",
                        { key: idx, staticClass: "flex max-w-64" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-2 text-left rounded truncate",
                              attrs: { title: i.name || "-" }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "truncate",
                                attrs: { text: i.name || "-" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "analytics-last-col-sticky pr-6 flex bg-slate-100 flex-grow"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "w-32 px-2 flex items-center justify-end flex-shrink-0 flex-grow bg-pure-white border-b border-r border-slate-400",
            class: { "rounded-br": _vm.isLast }
          },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: "/clients/" + _vm.item.id,
                  target: "_blank",
                  title: "View profile"
                }
              },
              [
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "View profile" }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d187c9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d187c9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/table/RowCancellationClient.vue
// module id = null
// module chunks = 